import React from "react";

export function MainLogo() {
  return (
    <svg
      width="150"
      height="60"
      viewBox="0 0 150 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_151)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7979 29.1291L40.1813 48.5126L57.5658 31.1281L28.7907 2.35297L22.7037 8.43991L45.3918 31.1281L39.8728 36.6473L26.5762 23.3506L20.7979 29.1291Z"
          fill="#3B7AFE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.015625 31.1281L17.2419 13.9019L23.3289 19.9888L12.1896 31.1281L34.8778 53.8163L28.7908 59.9032L0.015625 31.1281Z"
          fill="#3B7AFE"
        />
        <path
          d="M73.55 27.4598C75.8883 25.0932 78.7253 23.9099 82.0614 23.9099C85.4261 23.9099 88.2777 25.0932 90.6158 27.4598C92.9539 29.8266 94.123 32.678 94.123 36.0141C94.123 36.7271 94.066 37.5967 93.9519 38.6232H77.4422C77.7843 39.5641 78.4188 40.3268 79.3454 40.9115C80.2723 41.496 81.377 41.7883 82.6602 41.7883C84.7134 41.7883 86.3101 41.218 87.4507 40.0773L92.9682 43.5846C91.8561 44.9818 90.352 46.101 88.4557 46.9421C86.5596 47.7834 84.6278 48.204 82.6602 48.204C78.9819 48.204 75.9522 47.0276 73.5713 44.6754C71.1905 42.3229 70 39.4358 70 36.0141C70 32.678 71.1833 29.8266 73.55 27.4598ZM142.663 47.5364V24.3432H149.592V47.5364H142.663ZM118.906 15.354H138.494V22.454H126.263V28.6314H138.118V35.7314H126.263V47.5364H118.906V15.354ZM96.1516 30.5159V24.5359H113.877V29.596L104.906 41.2216H114.462V47.5364H95.912V42.8109L105.031 30.5159H96.1516ZM77.4849 33.4625H86.9374C86.7093 32.513 86.1603 31.7075 85.2907 31.0462C84.4211 30.385 83.3588 30.0543 82.1043 30.0543C80.8781 30.0543 79.8587 30.385 79.0461 31.0462C78.2335 31.7075 77.7131 32.513 77.4849 33.4625Z"
          fill="#3B7AFE"
        />
        <path
          d="M143.226 15.3511C142.419 16.1735 142.016 17.1481 142.016 18.2749C142.016 19.402 142.419 20.3691 143.226 21.1762C144.034 21.9833 145.001 22.3869 146.127 22.3869C147.254 22.3869 148.229 21.9758 149.052 21.1533C149.843 20.3615 150.239 19.402 150.239 18.2749C150.239 17.1481 149.836 16.1735 149.029 15.3511C148.221 14.5288 147.254 14.1177 146.128 14.1177C145.001 14.1177 144.034 14.5288 143.226 15.3511Z"
          fill="#5FBF24"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_151">
          <rect width="150" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RoundPlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256px"
      height="256px"
      viewBox="0 0 256 256"
      id="Flat"
    >
      <path d="M128,28A100,100,0,1,0,228,128,100.113,100.113,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.10447,92.10447,0,0,1,128,220Zm44-92a4.0002,4.0002,0,0,1-4,4H132v36a4,4,0,0,1-8,0V132H88a4,4,0,0,1,0-8h36V88a4,4,0,0,1,8,0v36h36A4.0002,4.0002,0,0,1,172,128Z" />
    </svg>
  );
}

export function CrossSquared() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="14" fill="#F4F9FD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.041 14.2423C29.601 13.8258 28.9125 13.8251 28.4716 14.2406L22.5 19.8679L16.5285 14.2406C16.0876 13.8251 15.3991 13.8258 14.9591 14.2423L14.8936 14.3042C14.4166 14.7557 14.4174 15.5155 14.8954 15.966L20.768 21.5L14.8954 27.034C14.4174 27.4845 14.4166 28.2443 14.8936 28.6958L14.9591 28.7577C15.3991 29.1742 16.0876 29.1749 16.5285 28.7594L22.5 23.1321L28.4716 28.7594C28.9125 29.1749 29.601 29.1742 30.041 28.7577L30.1064 28.6958C30.5835 28.2443 30.5826 27.4845 30.1046 27.034L24.232 21.5L30.1046 15.966C30.5826 15.5155 30.5835 14.7557 30.1064 14.3042L30.041 14.2423Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 3C4.34315 3 3 4.34315 3 6V8C3 9.65685 4.34315 11 6 11H8C9.65685 11 11 9.65685 11 8V6C11 4.34315 9.65685 3 8 3H6ZM16 3C14.3431 3 13 4.34315 13 6V8C13 9.65685 14.3431 11 16 11H18C19.6569 11 21 9.65685 21 8V6C21 4.34315 19.6569 3 18 3H16ZM3 16C3 14.3431 4.34315 13 6 13H8C9.65685 13 11 14.3431 11 16V18C11 19.6569 9.65685 21 8 21H6C4.34315 21 3 19.6569 3 18V16ZM16 13C14.3431 13 13 14.3431 13 16V18C13 19.6569 14.3431 21 16 21H18C19.6569 21 21 19.6569 21 18V16C21 14.3431 19.6569 13 18 13H16Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Membership() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.167 8.82115C19.167 12.5884 15.9956 15.6423 12.0835 15.6423C8.17139 15.6423 5 12.5884 5 8.82115C5 5.05393 8.17139 2 12.0835 2C15.9956 2 19.167 5.05393 19.167 8.82115ZM13.5408 6.17301L12.803 4.69753C12.4062 3.89831 11.7467 3.89831 11.3499 4.70312L10.6122 6.1786C10.5116 6.3798 10.2433 6.57541 10.0197 6.61454L8.68398 6.83809C7.82887 6.97782 7.62767 7.59819 8.24246 8.21297L9.27641 9.24692C9.44967 9.42577 9.55027 9.7667 9.49438 10.007L9.19816 11.2981C8.96343 12.3153 9.50556 12.7121 10.4054 12.1811L11.6629 11.4434C11.892 11.3092 12.2609 11.3092 12.49 11.4434L13.742 12.1867C14.6418 12.7177 15.1839 12.3208 14.9492 11.3037L14.653 10.0126C14.5971 9.7667 14.6977 9.42577 14.8709 9.25251L15.9105 8.20738C16.5253 7.5926 16.3241 6.97782 15.4689 6.83251L14.1332 6.60895C13.9096 6.57541 13.6414 6.37421 13.5408 6.17301Z" fill="#899CA8" />
      <path d="M16.0607 16.2827C16.407 16.1043 16.8058 16.3666 16.8058 16.7549V21.8445C16.8058 22.789 16.1446 23.2508 15.3261 22.8625L12.5137 21.5297C12.2723 21.4248 11.8945 21.4248 11.6532 21.5297L8.84075 22.8625C8.02221 23.2403 7.36108 22.7785 7.36108 21.8341L7.38207 16.7549C7.38207 16.3666 7.79134 16.1148 8.12715 16.2827C9.31298 16.8808 10.6562 17.2167 12.0834 17.2167C13.5106 17.2167 14.8643 16.8808 16.0607 16.2827Z" fill="#899CA8" />
    </svg>
  )
}

export function Marketing() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.69632 15.9166C3.00984 15.8975 2.44441 15.626 2.08836 15.0327C1.45041 13.9706 0.825546 12.9002 0.229036 11.8141C-0.247518 10.9471 0.0447392 9.85169 0.886615 9.33697C1.85663 8.74428 2.84954 8.18975 3.83591 7.62378C4.06055 7.4951 4.22904 7.56707 4.38334 7.83424C5.0949 9.06652 5.80592 10.2993 6.51748 11.5316C6.55128 11.5905 6.584 11.6516 6.62653 11.7039C6.73503 11.8375 6.92642 11.874 7.06764 11.7852C7.21759 11.6908 7.27538 11.5518 7.21759 11.3811C7.18978 11.2983 7.14289 11.2214 7.09872 11.145C6.39152 9.91821 5.68323 8.69193 4.97549 7.46511C4.79501 7.15267 4.82009 7.02454 5.11671 6.81571C7.45205 5.17012 9.38225 3.13904 10.9231 0.733917C11.5682 -0.273171 12.8855 -0.236639 13.4848 0.798803C15.0769 3.55071 16.6658 6.3048 18.2536 9.05998C18.8463 10.0883 18.2416 11.2197 17.0562 11.3201C16.3032 11.3839 15.5475 11.4318 14.7994 11.5344C12.8179 11.8064 10.9199 12.3762 9.09654 13.1968C7.67724 13.8359 6.38171 14.6985 5.02729 15.4542C4.61017 15.687 4.20341 15.94 3.69632 15.9166Z"
        fill="#899CA8"
      />
      <path
        d="M7.90255 20C7.50397 19.9482 7.173 19.8021 6.97562 19.4711C6.39383 18.4962 5.83003 17.5104 5.26569 16.5251C5.15501 16.3315 5.21226 16.1532 5.41019 16.0376C6.10321 15.633 6.79786 15.2323 7.4947 14.8342C7.70899 14.7121 7.88619 14.7612 8.01269 14.9793C8.56504 15.9324 9.12011 16.8839 9.65828 17.8446C9.95926 18.3817 9.78478 19.0185 9.26678 19.3457C9.00288 19.5125 8.73243 19.6729 8.45326 19.8119C8.28151 19.8986 8.08685 19.9395 7.90255 20Z"
        fill="#899CA8"
      />
      <path
        d="M17.7344 5.15982C17.7273 5.23452 17.7256 5.35775 17.7027 5.47716C17.6733 5.63147 17.5692 5.75579 17.4165 5.75034C17.2982 5.74652 17.1302 5.686 17.0746 5.59494C16.6651 4.92209 16.2769 4.23671 15.8854 3.55295C15.8052 3.41282 15.8336 3.27378 15.9405 3.15764C16.0555 3.03278 16.1973 3.02515 16.3521 3.08131C17.1569 3.37193 17.7393 4.2258 17.7344 5.15982Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Patients() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 2C9.37665 2 7.25 4.12665 7.25 6.75C7.25 9.37335 9.37665 11.5 12 11.5C14.6234 11.5 16.75 9.37335 16.75 6.75C16.75 4.12665 14.6234 2 12 2Z" fill="#899CA8" />
      <path d="M9 13C6.37665 13 4.25 15.1266 4.25 17.75C4.25 20.3734 6.37665 22.5 9 22.5H15C17.6234 22.5 19.75 20.3734 19.75 17.75C19.75 15.1266 17.6234 13 15 13H9Z" fill="#899CA8" />
    </svg>
  );
}

export function Leads() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2V7L12 7.05441C11.9999 7.47848 11.9998 7.8906 12.0455 8.23052C12.097 8.61372 12.2226 9.051 12.5858 9.41421C12.949 9.77743 13.3863 9.90295 13.7695 9.95447C14.1094 10.0002 14.5215 10.0001 14.9456 10H14.9456H14.9456H14.9456L15 10H20V16C20 18.8284 20 20.2426 19.1213 21.1213C18.2426 22 16.8284 22 14 22H10C7.17157 22 5.75736 22 4.87868 21.1213C4 20.2426 4 18.8284 4 16V8C4 5.17157 4 3.75736 4.87868 2.87868C5.75736 2 7.17157 2 10 2H12ZM14 2.00462V7C14 7.49967 14.0021 7.77383 14.0277 7.96402L14.0287 7.97131L14.036 7.97231C14.2262 7.99788 14.5003 8 15 8H19.9954C19.9852 7.58836 19.9525 7.31595 19.8478 7.06306C19.6955 6.69552 19.4065 6.40649 18.8284 5.82843L16.1716 3.17157C15.5935 2.59351 15.3045 2.30448 14.9369 2.15224C14.684 2.04749 14.4116 2.01481 14 2.00462ZM8 13C8 12.4477 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14L9 14C8.44772 14 8 13.5523 8 13ZM9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H9Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Agreement() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.95491 4.06107C3 5.3754 3 7.25027 3 11V13C3 16.7497 3 18.6246 3.95491 19.9389C4.26331 20.3634 4.6366 20.7367 5.06107 21.0451C6.3754 22 8.25027 22 12 22C15.7497 22 17.6246 22 18.9389 21.0451C19.3634 20.7367 19.7367 20.3634 20.0451 19.9389C21 18.6246 21 16.7497 21 13V11C21 7.25027 21 5.3754 20.0451 4.06107C19.7367 3.6366 19.3634 3.26331 18.9389 2.95491C17.6246 2 15.7497 2 12 2C8.25027 2 6.3754 2 5.06107 2.95491C4.6366 3.26331 4.26331 3.6366 3.95491 4.06107ZM8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75H16C16.4142 8.75 16.75 8.41421 16.75 8C16.75 7.58579 16.4142 7.25 16 7.25H8ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H16C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25H8ZM8 15.25C7.58579 15.25 7.25 15.5858 7.25 16C7.25 16.4142 7.58579 16.75 8 16.75H11C11.4142 16.75 11.75 16.4142 11.75 16C11.75 15.5858 11.4142 15.25 11 15.25H8Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Subscriptions() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.4499 13.5655V14.52C21.4499 14.7777 21.2399 14.9877 20.9599 14.9973H19.4999C18.9699 14.9973 18.4899 14.625 18.4499 14.1286C18.4199 13.8327 18.5399 13.5559 18.7399 13.365C18.9199 13.1836 19.1699 13.0882 19.4399 13.0882H20.9499C21.2399 13.0977 21.4499 13.3077 21.4499 13.5655Z"
        fill="#899CA8"
      />
      <path
        d="M17.9902 12.6586C17.4902 13.1264 17.2502 13.8232 17.4502 14.5486C17.7102 15.4364 18.6202 15.9995 19.5802 15.9995H20.4502C21.0002 15.9995 21.4502 16.4291 21.4502 16.9541V17.1354C21.4502 19.1114 19.7602 20.7245 17.6902 20.7245H6.2102C4.1402 20.7245 2.4502 19.1114 2.4502 17.1354V10.7114C2.4502 9.53727 3.0402 8.49681 3.9502 7.84772C4.5802 7.38954 5.3602 7.12227 6.2102 7.12227H17.6902C19.7602 7.12227 21.4502 8.73545 21.4502 10.7114V11.1314C21.4502 11.6564 21.0002 12.0859 20.4502 12.0859H19.4302C18.8702 12.0859 18.3602 12.2959 17.9902 12.6586Z"
        fill="#899CA8"
      />
      <path
        d="M16.2001 5.14636C16.4701 5.40409 16.2401 5.805 15.8601 5.805L8.18006 5.79545C7.74006 5.79545 7.51006 5.28 7.83006 4.98409L9.45006 3.42818C10.8201 2.13 13.0401 2.13 14.4101 3.42818L16.1601 5.11773C16.1701 5.12727 16.1901 5.13682 16.2001 5.14636Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function TreatmentPlan() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2V7L12 7.05441C11.9999 7.47848 11.9998 7.8906 12.0455 8.23052C12.097 8.61372 12.2226 9.051 12.5858 9.41421C12.949 9.77743 13.3863 9.90295 13.7695 9.95447C14.1094 10.0002 14.5215 10.0001 14.9456 10H14.9456H14.9456H14.9456L15 10H20V16C20 18.8284 20 20.2426 19.1213 21.1213C18.2426 22 16.8284 22 14 22H10C7.17157 22 5.75736 22 4.87868 21.1213C4 20.2426 4 18.8284 4 16V8C4 5.17157 4 3.75736 4.87868 2.87868C5.75736 2 7.17157 2 10 2H12ZM14 2.00462V7C14 7.49967 14.0021 7.77383 14.0277 7.96402L14.0287 7.97131L14.036 7.97231C14.2262 7.99788 14.5003 8 15 8H19.9954C19.9852 7.58836 19.9525 7.31595 19.8478 7.06306C19.6955 6.69552 19.4065 6.40649 18.8284 5.82843L16.1716 3.17157C15.5935 2.59351 15.3045 2.30448 14.9369 2.15224C14.684 2.04749 14.4116 2.01481 14 2.00462ZM8 13C8 12.4477 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14L9 14C8.44772 14 8 13.5523 8 13ZM9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H9Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Payment() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0336 3.25C15.4053 3.25 16.4807 3.24999 17.3451 3.32061C18.2252 3.39252 18.9523 3.54138 19.6104 3.87671C20.6924 4.42798 21.572 5.30762 22.1233 6.38955C22.5254 7.17877 22.6643 8.08233 22.7165 9.25H1.28354C1.33571 8.08233 1.47459 7.17877 1.87671 6.38955C2.42798 5.30762 3.30762 4.42798 4.38955 3.87671C5.04769 3.54138 5.77479 3.39252 6.65494 3.32061C7.51929 3.24999 8.59472 3.25 9.96644 3.25H14.0336Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.25227 10.75C1.25 11.1341 1.25 11.548 1.25 11.9942V12.0336C1.25 13.4053 1.24999 14.4807 1.32061 15.3451C1.39252 16.2252 1.54138 16.9523 1.87671 17.6104C2.42798 18.6924 3.30762 19.572 4.38955 20.1233C5.04769 20.4586 5.77479 20.6075 6.65494 20.6794C7.51924 20.75 8.59461 20.75 9.96623 20.75H14.0336C15.4052 20.75 16.4808 20.75 17.3451 20.6794C18.2252 20.6075 18.9523 20.4586 19.6104 20.1233C20.6924 19.572 21.572 18.6924 22.1233 17.6104C22.4586 16.9523 22.6075 16.2252 22.6794 15.3451C22.75 14.4808 22.75 13.4054 22.75 12.0338V11.9942C22.75 11.548 22.75 11.1341 22.7477 10.75H1.25227ZM5.25 17C5.25 16.5858 5.58579 16.25 6 16.25H8C8.41421 16.25 8.75 16.5858 8.75 17C8.75 17.4142 8.41421 17.75 8 17.75H6C5.58579 17.75 5.25 17.4142 5.25 17ZM10.25 17C10.25 16.5858 10.5858 16.25 11 16.25H15C15.4142 16.25 15.75 16.5858 15.75 17C15.75 17.4142 15.4142 17.75 15 17.75H11C10.5858 17.75 10.25 17.4142 10.25 17Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Financing() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2499 8.07996V10.94L10.2399 10.59C9.72992 10.41 9.41992 10.24 9.41992 9.36996C9.41992 8.65996 9.94992 8.07996 10.5999 8.07996H11.2499Z"
        fill="#899CA8"
      />
      <path
        d="M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z"
        fill="#899CA8"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Ezpay() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4H7C4 4 2 5.5 2 9V12.56C2 12.93 2.38 13.16 2.71 13.01C3.69 12.56 4.82 12.39 6.01 12.6C8.64 13.07 10.57 15.51 10.5 18.18C10.49 18.6 10.43 19.01 10.32 19.41C10.24 19.72 10.49 20.01 10.81 20.01H17C20 20.01 22 18.51 22 15.01V9C22 5.5 20 4 17 4ZM12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5ZM19.25 14C19.25 14.41 18.91 14.75 18.5 14.75C18.09 14.75 17.75 14.41 17.75 14V10C17.75 9.59 18.09 9.25 18.5 9.25C18.91 9.25 19.25 9.59 19.25 10V14Z"
        fill="#899CA8"
      />
      <path
        d="M5 14C2.79 14 1 15.79 1 18C1 18.75 1.21 19.46 1.58 20.06C2.27 21.22 3.54 22 5 22C6.46 22 7.73 21.22 8.42 20.06C8.79 19.46 9 18.75 9 18C9 15.79 7.21 14 5 14ZM6.97 17.67L4.84 19.64C4.7 19.77 4.51 19.84 4.33 19.84C4.14 19.84 3.95 19.77 3.8 19.62L2.81 18.63C2.52 18.34 2.52 17.86 2.81 17.57C3.1 17.28 3.58 17.28 3.87 17.57L4.35 18.05L5.95 16.57C6.25 16.29 6.73 16.31 7.01 16.61C7.29 16.91 7.27 17.39 6.97 17.67Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Ezplan() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2499 8.07996V10.94L10.2399 10.59C9.72992 10.41 9.41992 10.24 9.41992 9.36996C9.41992 8.65996 9.94992 8.07996 10.5999 8.07996H11.2499Z"
        fill="#899CA8"
      />
      <path
        d="M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z"
        fill="#899CA8"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function DiscountOffer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM8.73 7.66C9.54 7.66 10.21 8.32 10.21 9.14C10.21 9.95 9.55 10.62 8.73 10.62C7.92 10.62 7.25 9.96 7.25 9.14C7.25 8.32 7.91 7.66 8.73 7.66ZM8.85 15.8C8.7 15.95 8.51 16.02 8.32 16.02C8.13 16.02 7.94 15.95 7.79 15.8C7.5 15.51 7.5 15.03 7.79 14.74L14.34 8.19C14.63 7.9 15.11 7.9 15.4 8.19C15.69 8.48 15.69 8.96 15.4 9.25L8.85 15.8ZM15.27 16.34C14.46 16.34 13.79 15.68 13.79 14.86C13.79 14.05 14.45 13.38 15.27 13.38C16.08 13.38 16.75 14.04 16.75 14.86C16.75 15.68 16.09 16.34 15.27 16.34Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function UserLocation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8538 1.25C14.3096 1.24999 15.451 1.24999 16.3664 1.32925C17.2988 1.40998 18.0668 1.57719 18.7557 1.95335C19.7231 2.48162 20.5184 3.27685 21.0467 4.24432C21.4228 4.9332 21.59 5.70118 21.6708 6.63362C21.75 7.54902 21.75 8.69034 21.75 10.1461V13.2998C21.75 13.3587 21.75 13.3945 21.7497 13.4257C21.7282 15.4183 20.6939 17.1666 19.1403 18.181C18.2534 18.7601 17.1962 19.1011 16.0621 19.1133C16.031 19.1136 15.9954 19.1136 15.9371 19.1136L15.9253 19.1136L15.9241 19.1136C15.8571 19.114 15.793 19.1413 15.7463 19.1893L15.3854 19.5642C14.7399 20.235 14.2025 20.7932 13.7174 21.1768C13.206 21.5811 12.6625 21.8659 12 21.8659C11.3375 21.8659 10.794 21.5811 10.2826 21.1768C9.79744 20.7932 9.2601 20.2349 8.61454 19.5642L8.25452 19.1901L8.25371 19.1893C8.20698 19.1413 8.14293 19.114 8.07593 19.1136L8.0747 19.1136L8.06294 19.1136C8.052 19.1136 8.04186 19.1136 8.03239 19.1136C7.99139 19.1136 7.96317 19.1136 7.93795 19.1133C6.80376 19.1011 5.74659 18.7601 4.85969 18.181C3.30611 17.1666 2.27184 15.4183 2.25034 13.4257C2.25 13.3946 2.25 13.359 2.25 13.3005V10.1462C2.24999 8.69035 2.24999 7.54902 2.32925 6.63362C2.40998 5.70118 2.57719 4.9332 2.95335 4.24432C3.48162 3.27685 4.27685 2.48162 5.24432 1.95335C5.9332 1.57719 6.70118 1.40998 7.63362 1.32925C8.54903 1.24999 9.69036 1.24999 11.1462 1.25H12.8538ZM18.3912 16.8777C17.6839 15.7499 16.4295 15 15 15H9C7.5705 15 6.31614 15.7499 5.60882 16.8777C5.6323 16.8937 5.65596 16.9095 5.67978 16.9251C6.3345 17.3526 7.11403 17.6043 7.95413 17.6134C7.97604 17.6136 8.00293 17.6136 8.0687 17.6136L8.08422 17.6137C8.55323 17.6163 9.00157 17.807 9.32868 18.1431L9.33946 18.1543L9.65842 18.4857C10.3504 19.2046 10.8174 19.6875 11.2128 20.0001C11.5912 20.2991 11.8116 20.3659 12 20.3659C12.1884 20.3659 12.4088 20.2991 12.7872 20.0001C13.1826 19.6875 13.6496 19.2046 14.3416 18.4857L14.6605 18.1543L14.6713 18.1431C14.9984 17.807 15.4468 17.6163 15.9158 17.6137L15.9313 17.6136C15.9436 17.6136 15.9546 17.6136 15.9644 17.6136C16.007 17.6136 16.0281 17.6136 16.0459 17.6134C16.886 17.6043 17.6655 17.3526 18.3202 16.9251C18.344 16.9095 18.3677 16.8937 18.3912 16.8777ZM12 3.25C9.37665 3.25 7.25 5.37665 7.25 8C7.25 10.6234 9.37665 12.75 12 12.75C14.6234 12.75 16.75 10.6234 16.75 8C16.75 5.37665 14.6234 3.25 12 3.25Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Settings() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Logout() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8962 2C21.4065 2 21.8271 2.38604 21.8845 2.88338L21.8912 3V21C21.8912 21.5128 21.5071 21.9355 21.0122 21.9933L20.8962 22H14.9259C14.3763 22 13.9308 21.5523 13.9308 21C13.9308 20.4872 14.315 20.0645 14.8098 20.0067L14.9259 20H19.9011V4H14.9259C14.4156 4 13.995 3.61396 13.9375 3.11662L13.9308 3C13.9308 2.48716 14.315 2.06449 14.8098 2.00673L14.9259 2H20.8962ZM10.5605 6.2097L10.6542 6.29289L15.6295 11.2929C15.9882 11.6534 16.0158 12.2206 15.7123 12.6129L15.6295 12.7071L10.6542 17.7071C10.2656 18.0976 9.63562 18.0976 9.24702 17.7071C8.88832 17.3466 8.86073 16.7794 9.16425 16.3871L9.24702 16.2929L12.5228 13H2.98528C2.43573 13 1.99023 12.5523 1.99023 12C1.99023 11.4872 2.37436 11.0645 2.86924 11.0067L2.98528 11H12.5228L9.24702 7.70711C8.88832 7.34662 8.86073 6.77939 9.16425 6.3871L9.24702 6.29289C9.57583 5.96245 10.0775 5.91161 10.4595 6.14038L10.5605 6.2097Z"
        fill="#899CA8"
      />
    </svg>
  );
}


export function AppointmentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z" fill="#899CA8" />
      <path d="M20 9.84H4C3.45 9.84 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.84 20 9.84ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z" fill="#899CA8" />
    </svg>
  )
}

export function EContract() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.07 6.25 8.66 5.84C8.25 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z" fill="#899CA8" />
      <path d="M18.83 5.02999C18.6 4.83999 18.34 4.68999 18.06 4.57999C17.77 4.46999 17.48 4.69999 17.42 4.99999C17.08 6.70999 15.57 7.99999 13.75 7.99999H10.25C9.25 7.99999 8.31 7.60999 7.6 6.89999C7.08 6.37999 6.72 5.71999 6.58 5.00999C6.52 4.70999 6.22 4.46999 5.93 4.58999C4.77 5.05999 4 6.11999 4 8.24999V18C4 21 5.79 22 8 22H16C18.21 22 20 21 20 18V8.24999C20 6.61999 19.55 5.61999 18.83 5.02999ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z" fill="#899CA8" />
    </svg>
  )
}

export function Employees() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M6 7.75C6 5.67893 7.67893 4 9.75 4C11.8211 4 13.5 5.67893 13.5 7.75C13.5 9.82107 11.8211 11.5 9.75 11.5C7.67893 11.5 6 9.82107 6 7.75Z" fill="#899CA8" />
      <path d="M13.0994 4.38188C13.9645 5.24219 14.5 6.43355 14.5 7.75C14.5 9.06645 13.9645 10.2578 13.0994 11.1181C13.5974 11.3627 14.1577 11.5 14.75 11.5C16.8211 11.5 18.5 9.82107 18.5 7.75C18.5 5.67893 16.8211 4 14.75 4C14.1577 4 13.5974 4.13733 13.0994 4.38188Z" fill="#899CA8" />
      <path d="M3 16.75C3 14.6789 4.67893 13 6.75 13H12.75C14.8211 13 16.5 14.6789 16.5 16.75C16.5 18.8211 14.8211 20.5 12.75 20.5H6.75C4.67893 20.5 3 18.8211 3 16.75Z" fill="#899CA8" />
      <path d="M17.5 16.75C17.5 17.7749 17.1754 18.7239 16.6234 19.5H17.75C19.8211 19.5 21.5 17.8211 21.5 15.75C21.5 13.6789 19.8211 12 17.75 12H12.75C15.3734 12 17.5 14.1266 17.5 16.75Z" fill="#899CA8" />
    </svg>
  )
}

export function Refund() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M18.8101 6.25H20.1701C19.9801 5.98 19.7801 5.73 19.5701 5.48L18.8101 6.25Z" fill="#899CA8" />
      <path d="M18.52 4.42001C18.27 4.21001 18.02 4.01001 17.75 3.82001V5.18001L18.52 4.42001Z" fill="#899CA8" />
      <path d="M19.58 5.48L22.53 2.53C22.82 2.24 22.82 1.76 22.53 1.47C22.24 1.18 21.76 1.18 21.47 1.47L18.52 4.42C18.9 4.75 19.25 5.11 19.58 5.48Z" fill="#899CA8" />
      <path d="M17.7498 3C17.7498 2.59 17.4098 2.25 16.9998 2.25C16.5998 2.25 16.2798 2.57 16.2598 2.96C16.7798 3.21 17.2798 3.49 17.7498 3.82V3Z" fill="#899CA8" />
      <path d="M21.7499 7C21.7499 6.59 21.4099 6.25 20.9999 6.25H20.1699C20.4999 6.72 20.7899 7.22 21.0299 7.74C21.4299 7.72 21.7499 7.4 21.7499 7Z" fill="#899CA8" />
      <path d="M12.75 14.75H13.05C13.44 14.75 13.75 14.4 13.75 13.97C13.75 13.43 13.6 13.35 13.26 13.23L12.75 13.05V14.75Z" fill="#899CA8" />
      <path d="M21.04 7.74C21.03 7.74 21.02 7.75 21 7.75H17C16.9 7.75 16.81 7.73 16.71 7.69C16.53 7.61 16.38 7.47 16.3 7.28C16.27 7.19 16.25 7.1 16.25 7V3C16.25 2.99 16.26 2.98 16.26 2.96C14.96 2.35 13.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.48 21.65 9.04 21.04 7.74ZM13.75 11.82C14.39 12.04 15.25 12.51 15.25 13.98C15.25 15.23 14.26 16.26 13.05 16.26H12.75V16.51C12.75 16.92 12.41 17.26 12 17.26C11.59 17.26 11.25 16.92 11.25 16.51V16.26H11.17C9.84 16.26 8.75 15.14 8.75 13.76C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H11.25V12.53L10.25 12.18C9.61 11.96 8.75 11.49 8.75 10.02C8.75 8.77 9.74 7.74 10.95 7.74H11.25V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V7.75H12.83C14.16 7.75 15.25 8.87 15.25 10.25C15.25 10.66 14.91 11 14.5 11C14.09 11 13.75 10.66 13.75 10.25C13.75 9.7 13.34 9.25 12.83 9.25H12.75V11.47L13.75 11.82Z" fill="#899CA8" />
      <path d="M10.25 10.03C10.25 10.57 10.4 10.65 10.74 10.77L11.25 10.95V9.25H10.95C10.57 9.25 10.25 9.6 10.25 10.03Z" fill="#899CA8" />
    </svg>
  )
}